<template>
  <div id="app">
    <div v-show="loadingData">
        <img src="/static/assets/images/spinner.gif" style="display: block; margin-left: auto; margin-right: auto;">
      </div> 
    <div v-if="articles.length > 0">
      <div v-for="(article, loop_index) in articles" :key="article.id">
        <GenericStreamArticle 
          :article="article"
          :authenticated_user="authenticated_user"
          :ads="ads"
          :loop_index="loop_index"
        />
      </div>
    </div>
    <div v-else class="mt-2">
      <h4 v-if="!loadingData">Sembrerebbe che non sia presente alcun articolo al momento.</h4>
      <p v-if="!loadingData" class="lead">
        <a href="/scrivi/" style="text-decoration:underline">Scrivi tu un articolo!</a>
      </p>      
    </div>
    <div class="my-4">
      <div v-show="loadingData">
        <img src="/static/assets/images/spinner.gif" style="display: block; margin-left: auto; margin-right: auto;">
      </div> 
      <button
        v-show="next"
        @click="getStreamArticles()"
        class="btn btn-outline-success"
        >Carica Ancora
      </button>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { apiService } from "@/tools/api-service.js";
import GenericStreamArticle from './components/GenericStreamArticle.vue'

export default {
  name: 'app',
  components: {
    GenericStreamArticle,
  },
  data() {
    return {
      articles: [],
      authenticated_user: false,
      next: null,
      loadingData: false,
      ads: []
    }
  },
  methods: {
    async getStreamArticles() {
      let endpoint = stream_endpoint; // defined as GLOBAL in the related template.html
      this.loadingData = true;
      if (this.next) {
        endpoint = this.next;
      }
      await apiService(endpoint)
        .then(data => {
          this.articles.push(...data.results)
          this.loadingData = false;
          if (data.next) {
            this.next = data.next;
          } else {
            this.next = null;
          }
        })
    },
    async setIsAuthenticated() {
      let endpoint = "/api/core/user-status/";
      await apiService(endpoint)
        .then(data => {
          this.authenticated_user = data["is_authenticated"];
        })     
    },
    async setAdsArray() {
      let endpoint = ads_endpoint; // defined as GLOBAL in the related template.html
      await apiService(endpoint)
        .then(data => {
          this.ads = data;
          // console.log(this.ads)
        })
    }
  },
   created() {
    this.getStreamArticles()
    this.setIsAuthenticated()
    this.setAdsArray()
  }
}
</script>

<style>
[v-cloak] {
  display:none !important;
}
</style>